import { useCallback, useContext } from 'react';

import { StorageContext, UpdateStorageState } from 'context/storage/types';

export function createUseUpdateState<Type>(context: StorageContext<Type>) {
    function useUpdateState(): UpdateStorageState<Type>;
    function useUpdateState<Key extends keyof Type>(
        key: Key
    ): UpdateStorageState<Type[Key]>;

    function useUpdateState(key?: keyof Type) {
        const { update } = useContext(context);

        return useCallback<UpdateStorageState<unknown>>(
            (partialState) => {
                if (key) {
                    //any required because of dynamic key typing
                    //eslint-disable-next-line
                    (update as UpdateStorageState<any>)((currentState) => ({
                        [key]: {
                            ...(currentState[key] ?? {}),
                            ...(typeof partialState === 'function'
                                ? partialState(currentState[key])
                                : partialState),
                        },
                    }));
                } else {
                    update(partialState);
                }
            },
            [key, update]
        );
    }

    return useUpdateState;
}
